module.exports = __webpack_public_path__ + "static/img/preview-blue-with-progress-bar.cd34d2bd.png";